// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"b7ee5290","277":"b2b19aea","453":"29469fb7","610":"d2cc4ea8"}[chunkId] + ".chunk.js";
};